$(window).on("load", function () {
  $("#preloader").delay(1e3).fadeOut("slow");
}), $(document).ready(function () {
  $(".pictureChanger img.mainImgAlt").hide();

  $(".pictureChanger").hover(
    function () {
      $(this).find("img.mainImg").hide();
      $(this).find("img.mainImgAlt").show();
    },
    function () {
      $(this).find("img.mainImg").show();
      $(this).find("img.mainImgAlt").hide();
    }
  );

  $(".popup-gallery").magnificPopup({
    delegate: "a",
    type: "image",
    tLoading: "Loading image #%curr%...",
    preloader: true,
    mainClass: "mfp-img-mobile",
    gallery: {
      enabled: true,
      navigateByImgClick: true,
      preload: [4, 4], // Will preload 0 - before current, and 1 after the current image
    },
    image: {
      tError: '<a href="%url%">The image #%curr%</a> could not be loaded.',
      titleSrc: '',
    },
  });

  // $("body").on("mouseenter", ".pictureChanger", function (e) {
  //   $(this+' img.mainImg').hide();
  //   $(this+' img.mainImgAlt').show();
  // });

  // $("body").on("mouseleave", ".pictureChanger", function (e) {
  //   $(this+' img.mainImg').show();
  //   $(this+' img.mainImgAlt').hide();
  // });
});


  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll('a[title="Tasting Options"]').forEach(function (link) {
      link.setAttribute("target", "_blank");
    });
  });

